import { ParticipantsModel as Model } from './Model'


export const MODULE_NAME = 'participants'

export const PARTICIPANTS_ROUTES = {
  LAYOUT: MODULE_NAME,
  LIST: `${MODULE_NAME}.list`,
  VIEW: `${MODULE_NAME}.view`,
  EDIT: `${MODULE_NAME}.edit`,
  CREATE: `${MODULE_NAME}.create`,
} as const

export const MENU = {
  id: PARTICIPANTS_ROUTES.LAYOUT,
  route: { name: PARTICIPANTS_ROUTES.LAYOUT },
  label: Model.page_title.list,
  icon: 'mdi-account-search-outline',
} as const
